import React, { useEffect, useState } from 'react';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../../../components/Component';
import { useDispatch } from 'react-redux';
import * as app_consts from "../../../utils/app_consts";
import { fail_retrieve_product_types_by_status, loading_retrieve_product_types_by_status, reset_retrieve_product_types_by_status, success_retrieve_product_types_by_status } from '../../../reducers/auth_tenant/retrieve_product_types_by_status_Slice';
import { ADD_PRODUCT_ERROR_MSG, ADD_PRODUCT_SUCCESS_MSG, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { messageToast } from '../../../utils/Utils';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { CREATE_PRODUCT_API, RETRIEVE_TENANT_PRODUCT_TYPE_BY_STATUS_API } from '../../../api/api_data';
import TextInput from '../inputs/TextInput';
import ReadOnlyTable from '../table/ReadOnlyTable';
import { fail_add_product, loading_add_product, reset_add_product, success_add_product } from '../../../reducers/auth_tenant/add_product_Slice';

const initalState = { product_name: "", product_type_id: "", packet_sizes: [], returnable: false };

const AddProductModal = ({
 openModal,
 setOpenModal,
 type,
 modalTitle,
 modalDescription,
 succFunc,
 size,
 accountId,
 openOtherModalFunc,
 tenant_info
}) => {
 const [modal, setModal] = useState(false);
 const [step, setStep] = useState(1);
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const [formData, setFormData] = useState(initalState);

 const [product_types, setProductTypes] = useState([]);
 const [product_type_loading, setProductTypesLoading] = useState(true);
 const [edit_packet_size, setEditPacketSize] = useState(false);
 const [edit_packet_size_value, setEditPacketSizeValue] = useState("");
 const [input_packet_size_value, setInputPacketSizeValue] = useState("");

 const dispatch = useDispatch();

 const handleAddOrUpdate = (key, type, modify_packet_size = null) => {

  if (type === "add")
  {
   if (!input_packet_size_value)
   {
    messageToast("Size is required.", app_consts.FAIL);
    return;
   }

   const isDuplicate = formData.packet_sizes?.some((packet_size) => input_packet_size_value === packet_size);

   if (isDuplicate)
   {
    messageToast(`Duplicate size: ${input_packet_size_value}`, app_consts.FAIL);
    return formData.packet_sizes; // Avoid adding duplicates
   }
   else
   {
    formData.packet_sizes.push(input_packet_size_value);
    // setFormData({ ...formData, ["packet_sizes"]: new_packets });
    setInputPacketSizeValue("");
   }

  }

  if (type === "edit") 
  {
   if (!input_packet_size_value)
   {
    messageToast("Size is required.", app_consts.FAIL);
    return;
   }

   const isDuplicate = formData.packet_sizes?.some((packet_size) => input_packet_size_value === packet_size);

   if (isDuplicate)
   {
    messageToast(`Duplicate size: ${input_packet_size_value}`, app_consts.FAIL);
    return formData.packet_sizes; // Avoid adding duplicates
   }
   else
   {
    const updatedPacketSizes = formData.packet_sizes.map((pack) =>
     pack === edit_packet_size_value ? input_packet_size_value : pack
    );

    setFormData({ ...formData, packet_sizes: updatedPacketSizes });
    setInputPacketSizeValue("");
    setEditPacketSizeValue("");
    setEditPacketSize(false);
   }
  }

  if (type === "delete")
  {
   const updatedPacketSizes = formData.packet_sizes.filter(
    (pack) => pack !== modify_packet_size
   );

   setFormData({ ...formData, packet_sizes: updatedPacketSizes });
   setInputPacketSizeValue("");
   setEditPacketSizeValue("");
   setEditPacketSize(false);
  }
 };

 useEffect(() => {
  setError("");
  setFormData(initalState);
  setModal(openModal);
  retrieve_active_product_types();
 }, [openModal]);

 const toggleModal = () => {
  setOpenModal(!modal);
 };
 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const retrieve_active_product_types = () => {
  setError("");
  dispatch(tenant_auth_actions_helper(loading_retrieve_product_types_by_status, success_retrieve_product_types_by_status, fail_retrieve_product_types_by_status, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_PRODUCT_TYPE_BY_STATUS_API}/${app_consts.ACTIVE}`));
 };
 // Listen
 const retrieve_product_types_by_status_listener = useSelector((state) => state.retrieve_product_types_by_status.retrieve_product_types_by_status);
 // 
 useEffect(() => {
  if (retrieve_product_types_by_status_listener.status !== app_consts.IDLE)
  {
   if (retrieve_product_types_by_status_listener.status === app_consts.LOADING)
   {
    setProductTypesLoading(true);
   } else
   {
    setProductTypesLoading(false);
    if (retrieve_product_types_by_status_listener.status === app_consts.FAIL)
    {
     messageToast(retrieve_product_types_by_status_listener.message, app_consts.FAIL);
    } else if (retrieve_product_types_by_status_listener.status === app_consts.SUCCESS)
    {
     // Run Code to Get Product Type ID Ready for RSelect
     const mapped_product_types = retrieve_product_types_by_status_listener.data?.map((product_type) => {
      return ({
       label: product_type.product_type,
       value: product_type.id
      });

     });
     setProductTypes(mapped_product_types);
    }
    dispatch(reset_retrieve_product_types_by_status());
   }
  }
 }, [retrieve_product_types_by_status_listener]);

 const editPacketSizeToggle = ({ packet_size }) => {
  setEditPacketSize(true);
  setEditPacketSizeValue(packet_size);
  setInputPacketSizeValue(packet_size);
 };

 const handleSubmit = () => {
  setError("");
  // Dispatch
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_add_product, success_add_product, fail_add_product, ADD_PRODUCT_ERROR_MSG, ADD_PRODUCT_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${CREATE_PRODUCT_API}`, formData));
 };
 // Listen
 const add_product_listener = useSelector((state) => state.add_product.add_product);

 useEffect(() => {
  if (add_product_listener.status !== app_consts.IDLE)
  {
   if (add_product_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (add_product_listener.status === app_consts.FAIL)
    {
     setError(add_product_listener.message, app_consts.FAIL);
     messageToast(add_product_listener.message, app_consts.FAIL);
    } else if (add_product_listener.status === app_consts.SUCCESS)
    {
     succFunc();
     toggleModal();
    }
    dispatch(reset_add_product());
   }
  }
 }, [add_product_listener]);

 return (
  <>
   <Modal
    isOpen={modal}
    // toggle={!modalLoading ? toggleModal : ""}
    className="modal-dialog-centered"
    size={size ? size : "lg"}
   >
    <ModalHeader toggle={!loading ? toggleModal : ""}>{modalTitle}</ModalHeader>
    <ModalBody>
     <div className="d-flex justify-content-between mb-2">
      <h5 className="card-title text-center w-100">Add Product Form</h5>
     </div>{step === 2 && (
      <div
       className="nk-block-head-sub mb-2"
       style={{ cursor: "pointer" }}
       onClick={(e) => {
        e.preventDefault();
        setStep(1);
        setFormData({ ...formData, ["product_type"]: "" });
       }}
      >
       <Icon name="arrow-left" />
       <span>back</span>
      </div>
     )}
     {/* {error && (
      <div className="mb-3 w-100">
       <Alert color="danger" className="alert-icon">
        <Icon name="alert-circle" /> {error}{" "}
       </Alert>
      </div>
     )} */}
     <form
      onSubmit={(e) => {
       e.preventDefault();
      }}
     >
      <Row className="g-4">
       <Col size={6}>
        <div className="form-group">
         <label className="form-label mb-1 text-md" htmlFor="username">
          Product Type
         </label>
         <div className="form-control-wrap align-items-center w-100 d-flex flex-row mb-2 justify-between">
          <div className="w-85">
           <RSelect
            options={product_types}
            className="w-100"
            placeholder="Search"
            id="product_type_id"
            onChange={(e) => {
             setFormData({ ...formData, ["product_type_id"]: e.value });
            }}
            isDisabled={product_type_loading}
           />
          </div>
          <div className="w-5">
           {
            // Waiting for List to Load
            product_type_loading ? (
             <Spinner className="fs-16px" />
            ) : (
             <Link
              to="#reload"
              onClick={(e) => {
               e.preventDefault();
               retrieve_active_product_types();
              }}
             >
              <Icon name="reload-alt btn-icon fs-22px"></Icon>
             </Link>
            )
           }
          </div>
         </div>
        </div>
       </Col>
       <TextInput
        label="Product Name"
        required
        type="text"
        id_val="product_name"
        maxlength="100"
        value={formData.product_name}
        colSize="6"
        name="product_name"
        handleChange={(e) => {
         setFormData({ ...formData, ["product_name"]: e.target.value });
        }}
       />
       <Col sm="6" md="3">
        <div className="custom-control custom-checkbox">
         <input
          type="checkbox"
          className="custom-control-input"
          id={`returnable`}
          checked={formData.returnable}
          onChange={(e) =>
           setFormData({ ...formData, ["returnable"]: !formData.returnable })
          }
         />
         <label className="custom-control-label" htmlFor={`returnable`}>
          Returnable
         </label>
        </div>
       </Col>
       <div className="my-3">
        <p className="fs-18px fw-bold" style={{ marginBottom: 4 }}>Product Packet Sizes</p>

        <form
         onSubmit={(e) => {
          e.preventDefault();

         }}
        >
         <div style={{ marginBottom: 20, alignItems: "center" }}>
          <Row className="g-4">
           <TextInput
            label={`Packet Size`}
            required
            type="text"
            id_val={`packet_size`}
            maxlength="100"
            colSize="6"
            value={input_packet_size_value}
            handleChange={(e) => setInputPacketSizeValue(e.target.value)}
           />
          </Row>
         </div>
         <div style={{ marginBottom: 20, alignItems: "center" }}>
          <Row className="g-4">
           <Col size={4}>
            <Button color="gray"
             onClick={(e) => { e.preventDefault(); if (edit_packet_size) { handleAddOrUpdate(edit_packet_size_value, "edit"); } else { handleAddOrUpdate(edit_packet_size_value, "add"); setEditPacketSize(""); } }}
            >
             {edit_packet_size ? "Edit Packet Size" : "Add Packet Size"}
            </Button>
           </Col>
           {
            edit_packet_size && (
             <>
              <Col size={3}>
               <Button color="light"
                onClick={(e) => {
                 e.preventDefault(); setEditPacketSize(false); setEditPacketSizeValue("");
                }}
               >
                Cancel
               </Button>
              </Col>
             </>
            )
           }
          </Row>
         </div>
        </form>
        <ReadOnlyTable tableType={app_consts.ADD_EDIT_DELETE_PRODUCT_PACKET_SIZE_TABLE} data={formData?.packet_sizes} action_function={handleAddOrUpdate} setSelectedData={editPacketSizeToggle} />
       </div>
       {error && (
        <div className="mb-3 w-100">
         <Alert color="danger" className="alert-icon">
          <Icon name="alert-circle" /> {error}{" "}
         </Alert>
        </div>
       )}
       <Col xl="12" className="d-flex justify-content-end px-5">
        <Button onClick={handleSubmit} disabled={
         loading ||
         !(formData?.product_name && formData?.product_type_id) && formData.packet_sizes.length === 0
        } color="primary">
         {loading ? <Spinner size="sm" color="light" /> : "Add Product"}
        </Button>
       </Col>
      </Row>
     </form>
    </ModalBody>
   </Modal>
  </>
 );
};

export default AddProductModal;